// AUTO-GENERATED by scripts/convert-rn-icons.ts from libs/component-library/src/lib/icons/icons.tsx - do not edit.
import { FxSvg, type FxSvgProps } from '../FxSvg.js';

export const FxLoadingSpinnerIcon = (props: FxSvgProps) => (
  <FxSvg width={16} height={16} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.83045 1.8351C7.86006 2.10965 7.6615 2.35622 7.38695 2.38583C4.5568 2.69107 2.35303 5.08851 2.35303 7.99999C2.35303 10.9115 4.5568 13.3089 7.38695 13.6141C7.6615 13.6438 7.86006 13.8903 7.83045 14.1649C7.80084 14.4394 7.55427 14.638 7.27972 14.6084C3.94724 14.249 1.35303 11.4278 1.35303 7.99999C1.35303 4.57221 3.94724 1.75102 7.27972 1.3916C7.55427 1.36199 7.80084 1.56055 7.83045 1.8351Z"
    />
  </FxSvg>
);
